import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import router from '@/router';
import store from '@/store';
import axios from 'axios';
import filters from "@/filters";

// shared
import CustomBtn from "@/shared/CustomBtn/CustomBtn";
import SvgSprite from "@/shared/SvgSprite/SvgSprite";
import DatePicker from "@/shared/DatePicker/DatePicker";
import Field from "@/shared/Field/Field";
import Row from "@/shared/Row/Row";
import MainTable from "@/shared/MainTable/MainTable";

// components
import vuetify from './plugins/vuetify';
import VueClipboard from 'vue-clipboard2';
import MenuIcon from 'vue-material-design-icons/Menu';
import draggable from "vuedraggable";
import GroupFields from "@/shared/GroupFields/GroupFields";

// styles & directives
import 'vue-material-design-icons/styles.css';
import PhoneMaskUS from '@/directives/phoneMaskUS';
import InWindow from "@/directives/inWindow";

// init filters
filters();

// directives
Vue.use(InWindow);
Vue.directive('phone-mask-us', PhoneMaskUS);
Vue.use(VueClipboard);
Vue.use(VueRouter, Vuelidate, axios);

// shared components
Vue.component('menu-icon', MenuIcon);
Vue.component("svg-sprite", SvgSprite);
Vue.component("field", Field);
Vue.component("date-picker", DatePicker);
Vue.component("group-fields", GroupFields);
Vue.component("custom-btn", CustomBtn);
Vue.component("row", Row);
Vue.component("draggable", draggable);
Vue.component("main-table", MainTable);

Vue.config.productionTip = false;

/* ============================================================
   Управление цветом панели Safari (iOS)
   ============================================================ */

const THEME_COLORS = {
	light: '#ffffff', // светлая тема
	dark: '#22222d', // твой тёмный
};

function setThemeColor(isDark) {
	const color = isDark ? THEME_COLORS.dark : THEME_COLORS.light;

	let meta = document.querySelector('meta[name="theme-color"]');

	if (!meta) {
		meta = document.createElement('meta');
		meta.name = 'theme-color';
		document.head.appendChild(meta);
	}

	meta.setAttribute('content', color);
}

/**
 * Проставляем классы на <html>:
 *  - theme--dark / theme--light
 */
function applyThemeClasses(isDark) {
	document.documentElement.classList.toggle('theme--dark', isDark);
	document.documentElement.classList.toggle('theme--light', !isDark);
}

/* ============================================================ */

const app = new Vue({
	router,
	store,
	vuetify,

	provide() {
		// делаем themeIsDark реактивным через функцию
		return {
			themeIsDark: () => this.$vuetify.theme.dark
		};
	},

	created() {
		const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

		// 🧹 Нормализация старых значений темы
		const rawTheme = localStorage.getItem('theme');
		let savedTheme = null;

		if (rawTheme === 'dark' || rawTheme === 'light') {
			savedTheme = rawTheme;
		} else if (rawTheme === 'true' || rawTheme === '1') {
			savedTheme = 'dark';
			localStorage.setItem('theme', 'dark');
		} else if (rawTheme === 'false' || rawTheme === '0') {
			savedTheme = 'light';
			localStorage.setItem('theme', 'light');
		} else if (rawTheme !== null) {
			// какое-то мусорное значение — чистим
			localStorage.removeItem('theme');
		}

		// 1) Если пользователь выбрал вручную — используем её
		if (savedTheme === 'dark' || savedTheme === 'light') {
			this.$vuetify.theme.dark = savedTheme === 'dark';

			// 2) Иначе — режим "как у системы"
		} else {
			this.$vuetify.theme.dark = mediaQuery.matches;
		}

		// Применяем классы и meta theme-color сразу на старте
		applyThemeClasses(this.$vuetify.theme.dark);
		setThemeColor(this.$vuetify.theme.dark);

		// Слушаем смену системной темы (если пользователь не выбрал свою)
		const handleSystemThemeChange = (e) => {
			if (!localStorage.getItem('theme')) {
				this.$vuetify.theme.dark = e.matches;
				applyThemeClasses(e.matches);
				setThemeColor(e.matches);
			}
		};

		if (mediaQuery.addEventListener) {
			mediaQuery.addEventListener('change', handleSystemThemeChange);
		} else if (mediaQuery.addListener) {
			mediaQuery.addListener(handleSystemThemeChange);
		}

		// Подстраховка:
		// если где-то в коде ты меняешь тему вручную → классы и meta обновятся
		this.$watch(
			() => this.$vuetify.theme.dark,
			(isDark) => {
				applyThemeClasses(isDark);
				setThemeColor(isDark);
			}
		);
	},

	render: h => h(App)
}).$mount('#app');

export default app;
